export const sampleSlide1 = {
    deck_id: '',  
    deck_name: 'Sample',  // Deck name
    slide_number: 1,  // Slide number 
    slide_id: 'sample',  // Slide ID
    title: "How did we serve today?",  // The title of the slide
    background_color: "#fafafa",  // Background color of the slide
    text_style: {
      font_size: "48px",
      font_weight: "bold",
      font_family: "Arial",
      font_style: "normal",
      color: "#000000"
    },  // JSON field for styling
    image_url: "",  // Image URL for the slide image
    created_at: new Date().toISOString(),  // The current timestamp
    email: ''
  };

    export const sampleSlide2 = {
        deck_id: '',
        deck_name: 'Sample',  // Deck name
        slide_number: 2,  // Slide number 
        slide_id: 'sample',  //   Slide ID
        title: "My Feedback Question?",  // The title of the slide
        background_color: "#fafafa",
        text_style: {
            font_size: "44px",
            font_weight: "bold",
            font_family: "Arial",
            font_style: "normal",
            color: "#000000"
        },  // JSON field for styling
        image_url: "",  // Image URL for the slide image
        created_at: new Date().toISOString(),
        email: '',
        image_file: null  // The current timestamp
    };

    export const sampleSlide3 = {
        deck_id: '', 
        deck_name: 'Sample',  // Deck name
        slide_number: 3,  // Slide number 
        slide_id: 'sample',  // Slide ID
        title: "My Feedback Question?",  // The title of the slide
        background_color: "#fafafa",
        text_style: {
            font_size: "44px",
            font_weight: "bold",    
            font_family: "Arial",
            font_style: "normal",
            color: "#000000"
        },  // JSON field for styling
        image_url: "",  // Image URL for the slide image
        created_at: new Date().toISOString(),
        email: '',// The current timestamp
        image_file: null
    };

    
  